import React, { Component } from 'react';
export const Page = props => (
  <div className="project">

    {/* ==== EDIT BELOW THIS LINE ==== */}
    
    <h1> Shirt  Design: Verde Magazine </h1>

    
    <div className="imgs max700">
        <div>
            <img src={require('../assets/graphicDesign/verdeShirt.jpg')} data-skip-gallery/>
        </div>
    </div>

    <p>I designed the above shirt visuals 
    for <a href="https://verdemagazine.com/" target="_blank">Verde Magazine</a> during my 
    time as Art Director for the publication.</p>

    <p>The elements we wanted to illustrate in our apparel design were both a "fresh" theme 
    and a "professional" theme, thus the term "pro-freshional" (shortened to 
    "pro-fresh") was born. We utilized this term both within our organization and externally while 
    speaking about it. To illustrate the concept of "pro-fresh" as well as Verde (meaning 
    "green" in Spanish) itself, I came up with the visual of a fresh and vibrat lime wedge with 
    Verde's name inscribed inside.</p>
    



    {/* ==== EDIT ABOVE THIS LINE ==== */}

  </div>
)






// worked with the rabbi to developed visual 
    //symbols to represent each of the prayers in the Shabbat in order to guide the members 
    //with ASD through the ceremony. These symbols will be presented to the members via a 
    //large banner on the temple’s stage as well as on personal bookmarks that correspond 
    //with the banner. The bookmarks will also have a sticker packet with the symbols printed 
    //as stickers, to be placed on each of the corresponding sections for the current prayer 
    //on the bookmarks. The visually and physically interactive elements of these materials 
    //will help to add more sensorial aspects to the Shabbat, further benefitting Temple Sinai’s members with ASD.